var map = {
	"./assert": 305,
	"./assert.js": 305,
	"./behavior": 307,
	"./behavior.js": 307,
	"./call": 308,
	"./call.js": 308,
	"./collection": 309,
	"./collection.js": 309,
	"./extend": 310,
	"./extend.js": 310,
	"./format": 311,
	"./format.js": 311,
	"./log_error": 316,
	"./log_error.js": 316,
	"./match": 317,
	"./match.js": 317,
	"./mock": 318,
	"./mock.js": 318,
	"./sandbox": 319,
	"./sandbox.js": 319,
	"./spy": 320,
	"./spy.js": 320,
	"./stub": 321,
	"./stub.js": 321,
	"./test": 322,
	"./test.js": 322,
	"./test_case": 323,
	"./test_case.js": 323,
	"./times_in_words": 324,
	"./times_in_words.js": 324,
	"./typeOf": 325,
	"./typeOf.js": 325,
	"./util/core": 326,
	"./util/core.js": 326,
	"./util/event": 328,
	"./util/event.js": 328,
	"./util/fake_server": 329,
	"./util/fake_server.js": 329,
	"./util/fake_server_with_clock": 330,
	"./util/fake_server_with_clock.js": 330,
	"./util/fake_timers": 331,
	"./util/fake_timers.js": 331,
	"./util/fake_xdomain_request": 333,
	"./util/fake_xdomain_request.js": 333,
	"./util/fake_xml_http_request": 334,
	"./util/fake_xml_http_request.js": 334,
	"./util/timers_ie": 335,
	"./util/timers_ie.js": 335,
	"./util/xdr_ie": 336,
	"./util/xdr_ie.js": 336,
	"./util/xhr_ie": 337,
	"./util/xhr_ie.js": 337,
	"./walk": 338,
	"./walk.js": 338
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 306;



//////////////////
// WEBPACK FOOTER
// ./~/sinon/lib/sinon ^\.\/.*$
// module id = 306
// module chunks = 1